import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, Popconfirm } from "antd";
import { useEffect, useRef, useState, useMemo } from "react";
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, checkp, getAdmin, exportToCSV } from '../../utils/functions';
import CustModal from "../../components/ShowModal";
import DateSelector from "../../components/DateSelector";
import ReceiptForm from "./ReceiptForm";
import ReceiptDetails from "./ReceiptDetails";
import ExpenditureDetails from "./ExpenditureDetails";
import ViewModFiles from "../../components/ViewModFiles";
import DateInput from "../../components/DateInput";

const { Option } = Select;
const admin = getAdmin();
function SzList({ searchKeys }) {
    const webPost = useWebPost();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const pageSizeOptions = [10, 20, 50, 100, 500];

    const [form] = Form.useForm();
    const [editingRecord, setEditingRecord] = useState(null);
    const [activeKey, setActiveKey] = useState('0');
    const [inCome, setInCome] = useState(0);
    const [expend, setExpend] = useState(0);
    const [cbpm, setCbpm] = useState(0);
    const [dates, setDates] = useState(null);

    const loadingRef = useRef();
    useEffect(() => {
        const fetchItems = () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            try {
                const params = { page: currentPage, limit: pageSize, ...searchKeys, ...filters, ac: activeKey, ...dates };
                if (filters.singleMonth) {
                    const { startTs, endTs } = getMonthStartEnd(filters.singleMonth);
                    params.startTs = startTs;
                    params.endTs = endTs;
                }
                webPost('szlist', params).then((response) => {
                    if (response && response.data) {
                        if (response.total < 1) {
                            message.info('未找到匹配数据');
                        }
                        setData(response.data);
                        setTotal(response.total);
                        let ex = 0, ic = 0, cbp = 0;
                        response.data.forEach(it => {
                            if (Number(it.type) === 1) {
                                ic += (Number(it.this_receipt_amount) || 0)
                            } else {
                                ex += (Number(it.this_receipt_amount) || 0);
                                cbp += (Number(it.cbp_amount) || 0);
                            }
                        });
                        setInCome(ic.toFixed(2));
                        setExpend(ex.toFixed(2));
                        setCbpm(cbp.toFixed(2));
                    }
                })
            } catch (e) {
                setData([]);
                setTotal(0);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
        fetchItems();
    }, [searchKeys, currentPage, pageSize, freshData, activeKey]);

    const columns = [
        {
            title: '序号', dataIndex: 'xd', width: 80,
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        { title: '制单日期', dataIndex: 'make_date', width: 120 },
        {
            title: '统计日期', dataIndex: 'tj_date', width: 140, render: (_, rs) => (
                <div onDoubleClick={() => {
                    modtjdate(rs);
                }}>{_}</div>
            )
        },
        { title: '项目名称', dataIndex: 'xmmc', width: 200, },
        { title: '制单人', dataIndex: 'maker_name', width: 120, fixed: 'left' },
        { title: '科目', dataIndex: 'km', width: 80 },
        { title: '科目名称', dataIndex: 'kmmc', width: 120 },
        {
            title: '收入/支出', dataIndex: 'type', width: 90, render: (t) => {
                if (Number(t) === 1) {
                    return <span style={{ color: 'green' }}>收入</span>
                } else {
                    return <span style={{ color: 'red' }}>支出</span>
                }
            }
        },
        { title: '金额', dataIndex: 'this_receipt_amount', width: 140, },
        { title: '成本票金额', dataIndex: 'cbp_amount', width: 140, },
        { title: '备注', dataIndex: 'remark', width: 160, },
        {
            title: '附件', dataIndex: 'attachment', width: 100, render: (t, rs) =>
                <ViewModFiles table='cw_data' rs={rs} keys='attachment' canMod={(checkp(['cwinv']) || checkp(['cwckpz']))}></ViewModFiles>
        },
        {
            title: '出款凭证', dataIndex: 'attachment2', width: 100, render: (t, rs) =>
                <ViewModFiles table='cw_data' rs={rs} keys='attachment2' canMod={(checkp(['cwinv']) || checkp(['cwckpz']))}></ViewModFiles>
        },
        {
            title: '操作', dataIndex: 'ops', width: 160, render: (_, rs) => {
                const res = [];
                res.push(<Button onClick={() => { showModal(rs, 'details') }}>查看详情</Button>);
                if (searchKeys?.sn && Number(rs?.bank_id) === 6 && Number(rs?.type) === 1 && checkp('cwzhm')) {
                    res.push(<br />)
                    res.push(<Button onClick={() => showModal(rs, 'dh')}>兑汇</Button>)
                }
                return res;
            }
        },

    ].filter(Boolean);
    const dhcp = async (id) => {
        if (checkp('cwzhm')) {
            const values = await form.validateFields();

            // console.log(values, editingRecord, { id: editingRecord.id, ...values });
            if(Number(editingRecord?.left_amount)<Number(values.amount)){
                message.error("超出最大兑汇额度")
                return;
            }
            const res = await webPost('dhcp', { id: editingRecord.id, ...values });
            if (res) {
                saveSuccess();
            } else {
                message.error('兑汇失败');
            }
        }
    }
    const modtjdate = async (rs) => {
        if (checkp('mtjd')) {
            let inputvalue = '';
            Modal.confirm({
                title: '请输入新的日期',
                content: (<div>
                    <div><span>请在下面输入新日期</span></div>
                    <div><DateInput onChange={(e) => inputvalue = e} locale="zh-cn" /></div>
                </div>),
                onOk: (async () => {
                    const res = await webPost('tzdsv', { tbn: 'cw_data', zdn: 'tj_date', xid: rs.id, nv: inputvalue });
                    if (res) {
                        message.success('更新成功');
                        setData((prev) => prev.map((it) => (it.id === rs.id ? { ...rs, tj_date: inputvalue } : it)));
                    } else {
                        message.error('保存成功');
                    }
                }),
                onCancel: (() => { })
            })
        }
    }
    const showModal = async (record = null, action) => {
        setEditingRecord(record);
        setModalVisible(action);
    };

    const handleModalClose = () => {
        setModalVisible('');
        setEditingRecord(null);
    }
    const saveSuccess = () => {
        setfreshData(Math.random()); //强制刷新数据
        handleModalClose();
    };
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    return (
        <FullHeightLayout
            style={{ paddingTop: 0, marginTop: 0 }}
            headerStyle={{ paddingBottom: 0 }}
            headerContent={
                <>
                    {!(searchKeys && searchKeys.sn) && (
                        <Space size="middle">
                            <DateSelector onChange={(v) => { setDates(v); }} />
                            <Select placeholder='收支类型' style={{ width: '120px' }} onChange={(v) => setFilters(prev => ({ ...prev, "sx": v }))}>
                                <Option value='1'>收入</Option>
                                <Option value='2'>支出</Option>
                                <Option value='0'>全部</Option>
                            </Select>
                            <Select placeholder='类型' style={{ width: '120px' }} onChange={(v) => setFilters(prev => ({ ...prev, "lx": v }))}>
                                <Option value='1'>项目名称</Option>
                                <Option value='2'>项目编号</Option>
                                <Option value='3'>制单人</Option>
                                <Option value='4'>科目代码</Option>
                                <Option value='5'>金额</Option>
                            </Select>
                            <Input onChange={(e) => setFilters(prev => ({ ...prev, 'key': e.target.value }))} />
                            <Button type="primary" onClick={saveSuccess} >搜索</Button>
                        </Space>
                    )}

                    <Space size="middle" style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                        <div>当前页面：<span style={{ color: 'green' }}>（收入）￥{inCome}</span> / <span style={{ color: 'red', marginLeft: '10px' }}>（支出）￥{expend}</span> /
                            <span style={{ color: 'red' }}>（成本票）￥{cbpm}</span></div>
                        <Button onClick={() => { exportToCSV(data, columns, (data?.[0]['xmmc']) + '收支明细') }}>下载收支明细</Button>
                    </Space>
                </>
            }
            bodyContent={
                <>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey={(_, index) => index}
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 1440,
                            y: 'calc(100vh - 340px)',
                        }}
                        tableLayout="fixed"
                    />
                    <CustModal title='详情' open={modalVisible === 'details'} onCancel={handleModalClose} footer={false}>
                        {editingRecord?.type === 1 && <ReceiptDetails item={editingRecord} />}
                        {editingRecord?.type === 2 && <ExpenditureDetails item={editingRecord} />}
                    </CustModal>
                    <CustModal
                        title={'新增合同收款'}
                        open={modalVisible === 'edit'}
                        onCancel={handleModalClose}
                        footer={false}
                    >
                        <ReceiptForm sn='' onSave={saveSuccess} />
                    </CustModal>
                    <Modal
                        title={'兑换汇票'}
                        open={modalVisible === 'dh'}
                        onOk={dhcp}
                        onCancel={handleModalClose}
                    >
                        <h3>当前可兑汇最大金额为：<span style={{color:'red'}}>{editingRecord?.left_amount}</span></h3>
                        <Form form={form}
                            layout="vertical"
                        >
                            <Form.Item label="兑换金额" name="amount"><Input /></Form.Item>
                        </Form>
                    </Modal>
                </>
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                        onChange={onPageChange}
                        pageSizeOptions={pageSizeOptions}
                    />
                </div>
            }
        />
    )
}


export default SzList;
